export default ({
  state: {
    EmpleadoForm: [
      // { field: 'text', type: 'text', name: 'Clave empleado', nameid: 'cve_empleado', rules: true, cols: 4 },
      { field: 'text', type: 'text', name: 'Nombres', nameid: 'nombres', rules: true, cols: 4 },
      { field: 'text', type: 'text', name: 'Apellidos', nameid: 'apellidos', rules: true, cols: 4 },
      { field: 'number', type: 'number', name: 'Telefono/Celular', nameid: 'telefono', cols: 4 },
      { field: 'text', type: 'text', name: 'Calle', nameid: 'calle', rules: true, cols: 3 },
      { field: 'text', type: 'text', name: 'Numero', nameid: 'numero', rules: true, cols: 3 },
      { field: 'text', type: 'text', name: 'Cruzamiento 1', nameid: 'cruzamiento1', rules: true, cols: 3 },
      { field: 'text', type: 'text', name: 'Cruzamiento 2', nameid: 'cruzamiento2', rules: true, cols: 3 },
      { field: 'text', type: 'text', name: 'Codigo postal', nameid: 'cp', rules: true, cols: 6 },
      { field: 'textDatePicker', name: 'Fecha De Nacimiento', nameid: 'fecha_nacimiento', default: true, cols: 6 },
      { field: 'text', type: 'text', name: 'CURP', nameid: 'curp', rules: true, cols: 6 },
      { field: 'text', type: 'text', name: 'RFC', nameid: 'rfc', rules: false, cols: 6 },
      { field: 'number', type: 'number', name: 'id', nameid: 'empleado_id', cols: 12, hidden: true }
    ],
    // Configuraciones / Accesos - USUARIO
    UsersForm: [
      { field: 'text', type: 'text', name: 'Nombre Usuario', nameid: 'usuario', rules: true, cols: 12 },
      { field: 'searchDataServer', name: 'Colaborador', nameid: 'empleado_id', url: '/empresa/empleados/find', itemValue: 'id', rules: true, cols: 12 },
      { field: 'textEmail', type: 'email', name: 'Correo Electrónico', nameid: 'email', rules: true, cols: 12 },
      { field: 'text', type: 'password', name: 'Contraseña', nameid: 'password', rules: true, cols: 6 },
      { field: 'text', type: 'password', name: 'Confirmar Contraseña', nameid: 'confirmpassword', rules: true, cols: 6 }
    ],
    UsersUpdateForm: [
      { field: 'text', type: 'text', name: 'Nombre Usuario', nameid: 'usuario', rules: true, cols: 12 },
      { field: 'searchDataServer', name: 'Colaborador', nameid: 'empleado_id', url: '/empresa/empleados/find', itemValue: 'id', rules: true, cols: 12 },
      { field: 'textEmail', type: 'email', name: 'Correo Electrónico', nameid: 'email', rules: true, cols: 12 }
    ],
    PasswordUpdateForm: [
      { field: 'text', type: 'password', name: 'Nueva Contraseña', nameid: 'new_password', rules: true, cols: 12 },
      { field: 'text', type: 'password', name: 'Confirmar Contraseña', nameid: 'other_new_password', rules: true, cols: 12 }
    ],
    // Configuraciones / Accesos - ROLES
    RoleForm: [
      { field: 'text', type: 'text', name: 'Clave Role', nameid: 'slug', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Nombre Role', nameid: 'nombre', rules: true, cols: 12 }
    ],
    // Configuraciones / Accesos - PERMISOS
    PermisosForm: [
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Clave permiso', nameid: 'slug', rules: true, cols: 12 },
      { field: 'textArea', name: 'descripción', nameid: 'descripcion', dimens: 'input-7-1', rules: true, cols: 12 }
    ],
    // Catalogo
    UuAasForm: [
      { field: 'text', type: 'text', name: 'Nombre del Espacio', nameid: 'nombre', rules: true, cols: 12 }
    ],
    DeportesForm: [
      { field: 'text', type: 'text', name: 'Nombre', nameid: 'nombre', rules: true, cols: 12 }
    ],
    EspaciosForm: [
      { field: 'text', type: 'text', name: 'Nombre del Espacio', nameid: 'nombreE', rules: true, cols: 12 },
      { field: 'searchDataServer', type: 'search', name: 'Responsable', nameid: 'responsable', url: '/empresa/empleados/find', value: 'id', cols: 12 },
      { field: 'text', type: 'text', name: 'Calle', nameid: 'calle', rules: true, cols: 4 },
      { field: 'text', type: 'text', name: 'Numero', nameid: 'numero', rules: true, cols: 4 },
      { field: 'text', type: 'text', name: 'Cruzamiento 1', nameid: 'cruzamiento1', rules: true, cols: 4 },
      { field: 'text', type: 'text', name: 'Cruzamiento 2', nameid: 'cruzamiento2', rules: true, cols: 4 },
      { field: 'text', type: 'text', name: 'Código Postal', nameid: 'cp', rules: true, cols: 8 }
    ],
    LigasForm: [
      { field: 'text', type: 'text', name: 'Categoria', nameid: 'categoria', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Descripcion', nameid: 'descripcion', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Temporada', nameid: 'temporada', rules: true, cols: 12 }
    ],
    TiposPersonalForm: [
      { field: 'text', type: 'text', name: 'Posicion/Rol', nameid: 'nombre', rules: true, cols: 12 },
      { url: '/catalogo/deportes', cols: 12, name: 'Deporte', field: 'selectDataServer', nameid: 'deporte_id' }
    ],
    TeamsForm: [
      { field: 'number', type: 'number', name: 'Num. Maximo De Equipos', nameid: 'maxteam', cols: 12 }
    ],
    PlayersForm: [
      { field: 'number', type: 'number', name: 'Num. Maximo De Jugadores', nameid: 'maxplayer', cols: 12 }
    ],
    JugadoresForm: [
      { field: 'searchDataServer', type: 'search', name: 'Nombre Jugador', nameid: 'jugador_id', url: '/empresa/empleados/find', value: 'id', cols: 12 }
    ],
    DocumentForm: [
      { button: { name: 'Finalizar carga de documentos' }, fields: [{ cols: 12, name: 'Documentos', field: 'checklist', accept: 'application/pdf', dimens: 'input-7-1', nameid: 'documentos' }] }
    ],
    roleForm: [
      { field: 'text', type: 'text', name: 'Clave Role', nameid: 'slug', rules: true, cols: 12 },
      { field: 'text', type: 'text', name: 'Nombre Role', nameid: 'nombre', rules: true, cols: 12 }
    ],
    AssignRoles: [
      { field: 'viewText', name: 'Nombre Colaborador', nameid: 'NombreCompleto', cols: 12 },
      { field: 'viewText', name: 'Nombre Usuario', nameid: 'usuario', cols: 12 },
      { field: 'selectDataServer', name: 'Rol', nameid: 'rol_id', url: '/empresa/roles', rules: true, cols: 12 }
    ],
    RemoveRol: [
      { field: 'messageViewText', name: 'Estas seguro de eliminar el rol ?', classMain: 'text-center ma-auto text-h3', cols: 12 },
      { field: 'messageViewText', name: 'no podra revertir este moviminiento !!', classMain: 'text-center ma-auto title', cols: 12 }
    ],
    SelectUuAasForm: [
      { field: 'selectMultipleDataServer', name: 'UuAa', nameid: 'departamento_id', url: '/empresa/departamentos', rules: true, cols: 12 }
    ],
    RangeDateTimeForm: [
      { field: 'textDatePicker', name: 'Fecha Inicio', nameid: 'fecha_inicio', default: true, cols: 6 },
      { field: 'textDatePicker', name: 'Fecha Final', nameid: 'fecha_final', default: true, cols: 6 }
    ],
    PreviewPdfForm: [
      { field: 'previewpdf', nameid: 'ruta', params: 'data', name: 'PDF', cols: 12 }
    ],
    ImportForm: [
      { field: 'fileInputDataServer', type: 'fileInputDataServer', name: 'Layout Empleados', nameid: 'file', accept: '.xlsx,.xls', rules: true, cols: 12 },
      { field: 'number', type: 'number', name: 'id', nameid: 'equipo_id', cols: 12, hidden: true },
      { field: 'number', type: 'number', name: 'uuaa_id', nameid: 'uuaa_id', cols: 12, hidden: true }
    ],
    RolForm: [
      { url: '/catalogo/personal', cols: 12, name: 'Rol', field: 'selectDataServer', nameid: 'rol_id' }
    ],
    InvalideForm: [
      { field: 'select', type: 'select', name: 'Confirmar', nameid: 'confirmar', rules: true, cols: 12, items: [{ value: 'si', text: 'Sí' }, { value: 'no', text: 'No' }], placeholder: 'Seleccione una opción' }
    ],
    JornadaForm: [
      { field: 'select', type: 'select', name: 'Confirmar', nameid: 'confirmar', rules: true, cols: 12, items: [{ value: 'si', text: 'Sí' }, { value: 'no', text: 'No' }], placeholder: 'Seleccione una opción' },
      { field: 'text', type: 'text', name: 'Periodo', nameid: 'periodo', rules: true, cols: 12 },
      { field: 'select', type: 'select', name: 'Tipo Jornada', nameid: 'tipo_jornada', rules: true, cols: 12, items: [{ value: 'ida', text: 'Ida' }, { value: 'vuelta', text: 'Ida y Vuelta' }], placeholder: 'Seleccione una opción' }
    ],
    LiguillaForm: [
      { field: 'select', type: 'select', name: 'Tipo', nameid: 'tipo', rules: true, cols: 12, items: [{ value: 'cuartos', text: 'Cuartos' }, { value: 'semifinal', text: 'Semifinal' }, { value: 'final', text: 'Final' }], placeholder: 'Seleccione una opción' },
      { field: 'select', type: 'select', name: 'Tipo Jornada', nameid: 'tipo_jornada', rules: true, cols: 12, items: [{ value: 'ida', text: 'Ida' }, { value: 'ida_vuelta', text: 'Ida y Vuelta' }], placeholder: 'Seleccione una opción' }
    ],
    MarcadorForm: [
      { field: 'number', type: 'number', name: 'Equipo Local', nameid: 'local', cols: 6, value: 'this.objectMain?.resul_local ?? 0' },
      { field: 'number', type: 'number', name: 'Equipo Visitante', nameid: 'visitante', cols: 6, value: 'this.objectMain?.resul_visitante ?? 0' }
    ],
    PlantillaForm: [
      { cols: 12, name: 'Documento', field: 'fileInputDataServer', rules: 'Required', accept: 'application/pdf', nameid: 'archivo_pdf' }
    ]
  },
  getters: {
    // Configuraciones
    get_EmpleadoForm (state) { return state.EmpleadoForm },
    // Configuraciones / Accesos
    get_UsersForm (state) { return state.UsersForm },
    get_UsersUpdateForm (state) { return state.UsersUpdateForm },
    get_PasswordUpdateForm (state) { return state.PasswordUpdateForm },
    // Configuraciones / Accesos - USURARIO
    get_RoleForm (state) { return state.RoleForm },
    // Configuraciones / Accesos - ROLES
    get_PermisosForm (state) { return state.PermisosForm },
    // Catalogo
    get_DeportesForm (state) { return state.DeportesForm },
    get_LigasForm (state) { return state.LigasForm },
    get_TiposPersonalForm (state) { return state.TiposPersonalForm },
    get_UuAasForm (state) { return state.UuAasForm },
    get_EspaciosForm (state) { return state.EspaciosForm },
    get_TeamsForm (state) { return state.TeamsForm },
    get_PlayersForm (state) { return state.PlayersForm },
    get_JugadoresForm (state) { return state.JugadoresForm },
    get_ImportForm (state) { return state.ImportForm },
    get_DocumentForm (state) { return state.DocumentForm },
    get_InvalideForm (state) { return state.InvalideForm },
    get_RolForm (state) { return state.RolForm },
    get_MarcadorForm (state) { return state.MarcadorForm },
    get_PlantillaForm (state) { return state.PlantillaForm },
    get_JornadaForm (state) { return state.JornadaForm },
    get_LiguillaForm (state) { return state.LiguillaForm },

    // ===== * ===== * ===== * ===== * ===== * ===== * ===== * ===== \\
    get_AssignRoles (state) { return state.AssignRoles },
    get_RemoveRol (state) { return state.RemoveRol },
    get_SelectUuAasForm (state) { return state.SelectUuAasForm }
  },
  mutations: {},
  actions: {}
})
